<div class="bb-toast animated fadeIn" [ngClass]="{fadeOutDown: !visible}">
	<i class="fa fa-{{icon}}"></i> <span class="contents">{{message}}</span>
</div>
